// A failed API call as one line for a form: the message plus each field error
// (key: code, detail) - e.g. "invalid attributes - site: required".
import type { T } from "../i18n";

export interface FieldError { key?: string; field?: string; code?: string; detail?: string; message?: string }
export function errText(t: T, e: unknown): string {
  const err = e as { message?: string; field_errors?: FieldError[] };
  const fe = (err?.field_errors || []).map((f) => {
    const code = f.code ? (t("x.fe." + f.code) === "x.fe." + f.code ? f.code : t("x.fe." + f.code)) : "";
    return `${f.key || f.field || "?"}: ${code}${f.detail || f.message ? ` (${f.detail || f.message})` : ""}`;
  });
  return t("x.error", { m: [err?.message || String(e), ...fe].join(" · ") });
}
